// src/components/finance/FinanceNav.jsx
import React from 'react'
import { NavLink } from 'react-router-dom'

const tabs = [
  { to: '/finance', label: 'Accueil' },
  { to: '/finance/journal', label: 'Journal' },
  { to: '/finance/ledger', label: 'Grand livre' },
  { to: '/finance/trial-balance', label: 'Balance' },
  { to: '/finance/profit-loss', label: 'Résultat' },
  { to: '/finance/vat', label: 'TVA' },
  { to: '/finance/cashflow', label: 'Trésorerie' },
  { to: '/finance/periods', label: 'Périodes' },
  { to: '/finance/export', label: 'Exports' },
  { to: '/finance/audit', label: 'Audit' },
]

export default function FinanceNav() {
  return (
    <div className="flex flex-wrap gap-2 text-xs">
      {tabs.map((t) => (
        <NavLink
          key={t.to}
          to={t.to}
          className={({ isActive }) =>
            `px-3 py-1.5 rounded-lg border transition-colors ${
              isActive ? 'bg-slate-900 text-white border-slate-900' : 'bg-white border-slate-200 text-slate-600 hover:bg-slate-50'
            }`
          }
        >
          {t.label}
        </NavLink>
      ))}
    </div>
  )
}
